import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { CustomerResponse } from "../types/CustomerResponse"
import type { CustomersResponse } from "../types/CustomersResponse"
import type { GetCustomersParameters } from "../types/GetCustomerParameters"
import type { ModuleResponse } from "../types/ModuleResponse"

const { cmApiBaseUrl } = getPublicConfig()
const customerApiBaseUrl = `${cmApiBaseUrl}/v1/customers`

export const createCustomerApi = (client: HttpClient) => ({
  getCustomers: async (params: GetCustomersParameters): Promise<CustomersResponse> =>
    client.get<CustomersResponse>(customerApiBaseUrl, {
      page: params.page?.toString() ?? "0",
      pageSize: params.pageSize?.toString() ?? "100",
      searchTerm: params.searchTerm ?? "",
      sortBy: params.sortBy ?? "",
      salesforceId: params.salesforceId ?? "",
      sdmEmail: params.sdmEmail ?? "",
      relationshipType: params.relationshipType ?? "",
      relationshipSubtype: params.relationshipSubType ?? "",
      sortOrder: params.sortOrder ?? "ASC"
    }),

  getCustomer: async (customerId: string): Promise<CustomerResponse> =>
    client.get<CustomerResponse>(`${customerApiBaseUrl}/${customerId}`),

  getModules: async (customerId: string): Promise<ModuleResponse> =>
    client.get<ModuleResponse>(`${customerApiBaseUrl}/${customerId}/modules`),

  getAiDescription: async (customerId: string): Promise<string> =>
    client
      .get<{
        meta: { timestamp: string; version: string }
        data: { description: string }
      }>(`${customerApiBaseUrl}/${customerId}/ai_description`)
      .then(({ data }) => data.description)
})
